module.exports = __webpack_public_path__ + "img/64d27f4eedfdf3e3e15552e82085612e.png";